import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LogosDialogContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const LogosDialogGrid = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(6, 1fr)',
  gap: '8px',
  padding: '8px 0',
  justifyItems: 'center',
  maxWidth: '480px',
  margin: '0 auto',

  '& > :nth-of-type(1)': {
    gridColumn: '1 / span 2',
  },

  '& > :nth-of-type(2)': {
    gridColumn: '3 / span 2',
  },

  '& > :nth-of-type(3)': {
    gridColumn: '5 / span 2',
  },

  '& > :nth-of-type(4)': {
    gridColumn: '2 / span 2',
    gridRow: '2',
  },

  '& > :nth-of-type(5)': {
    gridColumn: '4 / span 2',
    gridRow: '2',
  },
}));

export const LogosDialogButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  padding: '16px 12px',
  border: `2px solid ${selected ? 'var(--color-accent)' : 'var(--color-type-secondary-dark)'}`,
  background: '#fff',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  minHeight: '100px',
  textTransform: 'none',

  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },

  [theme.breakpoints.down('sm')]: {
    minHeight: '80px',
    padding: '12px 8px',
  },
}));

export const LogosDialogImage = styled('img')(({ theme }) => ({
  width: '60px',
  height: '40px',
  objectFit: 'contain',

  [theme.breakpoints.down('sm')]: {
    width: '50px',
    height: '32px',
  },
}));

export const LogosDialogName = styled('p')(() => ({
  fontSize: '12px',
  fontWeight: 600,
  color: '#000',
  textAlign: 'center',
  textDecoration: 'none',
  margin: 0,
}));
